import { useState } from "react";
import { C } from "../constants";

export const MuscleBalanceCard = ({ muscleBalance, maxMuscle }) => {
  const [expanded, setExpanded] = useState(false);

  const untrainedGroups = muscleBalance.filter(g => g.subgroups.every(s => s.count === 0)).map(g => g.group);
  const untrainedSubs   = muscleBalance.flatMap(g => g.subgroups.filter(s => s.count === 0 && g.subgroups.some(x => x.count > 0))).map(s => s.name);

  return (
    <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, marginBottom: 16, overflow: "hidden" }}>
      <div onClick={() => setExpanded(e => !e)} style={{ padding: "18px 20px", cursor: "pointer" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <div style={{ color: C.muted, fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em" }}>
            Muscle Balance <span style={{ fontSize: 10, fontWeight: 400, textTransform: "none", letterSpacing: 0 }}>— last 30 days</span>
          </div>
          <div style={{ color: C.muted, fontSize: 12, display: "flex", alignItems: "center", gap: 6 }}>
            <span>{expanded ? "Less" : "Details"}</span>
            <span style={{ fontSize: 10 }}>{expanded ? "▲" : "▼"}</span>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {muscleBalance.map(({ group, subgroups }) => {
            const total   = subgroups.reduce((s, sg) => s + sg.count, 0);
            const allZero = total === 0;
            return (
              <div key={group} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ width: 76, fontSize: 12, color: allZero ? C.muted : C.text, fontWeight: allZero ? 400 : 600, flexShrink: 0 }}>{group}</div>
                <div style={{ flex: 1, background: C.surface, borderRadius: 4, height: 8, overflow: "hidden" }}>
                  <div style={{
                    height: "100%", borderRadius: 4,
                    width: `${(total / maxMuscle) * 100}%`,
                    background: allZero ? "transparent" : total === maxMuscle ? C.blue : C.blue + "99",
                    minWidth: total > 0 ? 6 : 0,
                    transition: "width 0.4s ease",
                  }} />
                </div>
                <div style={{ width: 28, textAlign: "right", fontSize: 12, color: allZero ? C.muted : C.textDim }}>
                  {allZero ? "—" : (total % 1 === 0 ? total : total.toFixed(1))}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {expanded && (
        <div style={{ borderTop: `1px solid ${C.border}`, padding: "16px 20px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            {muscleBalance.map(({ group, subgroups }) => {
              const allZero    = subgroups.every(sg => sg.count === 0);
              const totalCount = subgroups.reduce((s, sg) => s + sg.count, 0);
              return (
                <div key={group}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: allZero ? C.muted : C.text }}>{group}</div>
                    {allZero
                      ? <span style={{ fontSize: 10, color: C.red + "cc", fontWeight: 600 }}>not trained</span>
                      : <span style={{ fontSize: 11, color: C.muted }}>{totalCount % 1 === 0 ? totalCount : totalCount.toFixed(1)} sets</span>
                    }
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 7, paddingLeft: 10, borderLeft: `2px solid ${allZero ? C.border : C.blue + "44"}` }}>
                    {subgroups.map(({ name, count }) => (
                      <div key={name} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div style={{ width: 100, fontSize: 11, color: count === 0 ? C.muted : C.textDim, flexShrink: 0 }}>{name}</div>
                        <div style={{ flex: 1, background: C.surface, borderRadius: 3, height: 6, overflow: "hidden" }}>
                          <div style={{
                            height: "100%", borderRadius: 3,
                            width: `${(count / maxMuscle) * 100}%`,
                            background: count === 0 ? "transparent" : count === maxMuscle ? C.blue : C.blue + "88",
                            minWidth: count > 0 ? 4 : 0,
                            transition: "width 0.4s ease",
                          }} />
                        </div>
                        <div style={{ width: 32, textAlign: "right", fontSize: 11, color: count === 0 ? C.border : C.muted }}>
                          {count > 0 ? (count % 1 === 0 ? count : count.toFixed(1)) : "—"}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          {(untrainedGroups.length > 0 || untrainedSubs.length > 0) && (
            <div style={{ marginTop: 16, padding: "10px 12px", background: C.surface, borderRadius: 8, fontSize: 12, color: C.muted, lineHeight: 1.5 }}>
              {untrainedGroups.length > 0 && (
                <div>💡 <strong style={{ color: C.text }}>{untrainedGroups.join(", ")}</strong> — no work logged this month</div>
              )}
              {untrainedSubs.length > 0 && (
                <div style={{ marginTop: untrainedGroups.length > 0 ? 4 : 0 }}>
                  ⚠️ Untrained areas: <span style={{ color: C.text }}>{untrainedSubs.slice(0, 6).join(", ")}{untrainedSubs.length > 6 ? ` +${untrainedSubs.length - 6} more` : ""}</span>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
